<template>
  <div
    id="delete-diagram-modal"
    tabindex="-1"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-md max-h-full">
      <div class="relative bg-white rounded-lg shadow ">
        <button
          type="button"
          class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center "
          @click="onClose"
        >
          <svg
            class="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <div class="p-4 md:p-5 text-center">
          <svg
            class="mx-auto mb-4 text-gray-400 w-12 h-12 "
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          <h3 class="mb-5 text-lg font-normal text-gray-500 ">
            Etes-vous certain de vouloir supprimer :<br> <span class="font-semibold italic">{{ input.name }}</span> ?
          </h3>
                      
                      
                     
          <button
            type="button"
            class="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
            @click="onConfirm(input)"
          >
            Oui, je confirme
          </button>
          <button
            type="button"
            class="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100      "
            @click="onClose"
          >
            Non, annuler
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    
    import labels from "@/assets/lg/product-types.json"
    export default {
        name: 'DeleteDiagramModal',
        components: {
           
        },
        props: {
            input: Object
        },
        data() {
            return ({
                lg: "FR",
                labels: labels,
                lines: [

                    {
                        id: "1",
                        name: "Sélection Date"
                    },
                    {
                        id: "2",
                        name: "Température Frigo #1"
                    },
                    {
                        id: "3",
                        name: "P1"
                    }

                ],
                types: [],
            })
        },

        computed: {
          
        },
        async mounted() {
           
        },
        methods: {
            onConfirm(item) {
                this.$emit("confirm", item)
            },
            onClose() {
                this.$emit("close")
            }
        },
    }
</script>